export {
    Check as IconCheck,
    Link as IconLink,
    FileDown as IconFileDown,
    FolderDown as IconFolderDown,
    Text as IconText,
} from 'lucide-react';
export * from './file-types';
export * from './generic';
export * from './social';

export type { IconComponentType } from './types';
